module.exports = __webpack_public_path__ + "media/images/about-e9ea3a542e233cff94cdeeb583b66097.png";